import React from "react"
import Link, { ExternalLink } from "./link"

const links = [
    ['Explore', '/'],
    ['Tours', '/tours'],
    ['Submit Art', '/submit-art'],
    ['About', '/about'],
    ['Partners', '/partners'],
]

function Nav({linkSx, inline}) {
    return (
        <nav>
            <ul style={{listStyleType: 'none'}}>
                {links.map(([linkText, linkPath]) => <Link 
                    inline={inline}
                    key={linkPath} 
                    to={linkPath} 
                    ssx={{
                        mr: 3,
                        ...linkSx
                    }}>{linkText}</Link>)}
            </ul>
        </nav>
    )
}

export default Nav